import "../scss/style.scss";
import "./components/Header";
import "./components/Modules";
import "./components/Accordion";
import "./components/Gallery";
